import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { PlusOutlined } from "@ant-design/icons";
import { useNavModel } from "@/model/navModel";
import { userControlModel } from "../userControlModel";
import { globalPrompt } from "@/components/message";
import { UserDetail } from "./UserDetail";

export const DataBox = () => {
    const { selectedRowKeys, updateEditFormVal, loadData,userDetailVisible, setUserDetailVisible } = userControlModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const exportData = () => {
       
    }

    // const onEdit = () => {
    //     if (selectedRowKeys.length !== 1) {
    //         globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
    //         return;
    //     }
    //     setUserDetailVisible(true);
    // }

    const action = <>
        {/* <Button
            className="mr-5"
            shape="round"
            onClick={onEdit}
        >查看</Button> */}
        {/* <Button
            className="mr-5"
            shape="round"
            onClick={exportData}
        >同步</Button> */}
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable/>
            {userDetailVisible && <UserDetail/>}
        </YhBox>
    )
}
